module.exports = __webpack_public_path__ + "img/zone2schedule.23c042bb.png";